/**
 * Admin module constants
 */

export const POP_MODEL = {
    EDITOR: 'edit',
    VIEWER: 'view',
};

export const PROMPT_MODES = {
    ADD: 'add',
    EDIT: 'edit',
};

export const PROMPT_DIALOG = {
    HEADINGS: {
        ADD: 'Add Feature Prompt',
        EDIT: 'Update Prompt',
    },
    ACTION_LABELS: {
        ADD: 'Save',
        EDIT: 'Update',
    },
};

export const PROMPT_FEATURE_ITEMS = ['instruction', 'output', 'business_context', 'guard_rails', 'input'];

export const MESSAGES = {
    SUCCESS: {
        STATUS_CHANGED: 'Status changed successfully',
        PROMPT_UPDATED: 'Prompt updated successfully',
        FEATURE_PROMPT_CREATED: 'Feature prompt created successfully',
    },
    ERROR: {
        FAILED_UPDATE_FEATURE: 'Failed to update feature',
        CONTENT_REQUIRED: 'Content is required',
        FEATURE_REQUIRED: 'Feature is required',
        TYPE_REQUIRED: 'Type is required',
        FILL_REQUIRED_FIELDS: 'Please fill in all required fields',
        ERROR_UPDATING_PROMPT: 'Error Updating Prompt',
        ERROR_CREATING_FEATURE_PROMPT: 'Error creating feature prompt',
        UNKNOWN_ERROR: 'Unknown error!',
    }
};